import {
    Dialog, DialogContent, DialogTitle, Grid, Icon, Typography,
} from '@mui/material';
import React from 'react';
import { Warning } from '@mui/icons-material';
import { getJsonPath } from '../../utils/constants';
import useStore from '../../store/store';
import ActionButton from '../ActionButton/ActionButton';
import { Store } from '../../store/types';
import { clearAllDataAndReload } from '../../utils/localStorage';

type Props = {
};

const AppVersionMismatchDialog = (props: Props) => {
    console.log(props);
    const appVersionMismatch = useStore((state: Store) => state.appVersionMismatch);

    const onReloadButtonClick = () => {
        clearAllDataAndReload();
    };

    return (
        <Dialog
            open={appVersionMismatch || false}
            maxWidth="sm"
            disableRestoreFocus
        >
            <DialogTitle>
                <div
                    style={{
                        height: '150px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <img
                        src={getJsonPath('/updated.svg')}
                        alt="Session Timed Out"
                        width="200px"
                        height="100px"
                    />
                    <h3>
                        Latest Version Available
                    </h3>
                </div>
            </DialogTitle>
            <DialogContent>
                <Grid
                    container
                    sx={{
                        paddingTop: '3rem',
                    }}
                    spacing={3}
                    justifyContent="center"
                >
                    <Grid
                        item
                        sm={10}
                        md={10}
                        lg={10}
                        style={{
                            textAlign: 'left',
                        }}
                    >
                        <Typography>
                            Great news!
                            The app version has been updated.
                            Kindly refresh your page to access the
                            latest version and ensure a seamless experience
                        </Typography>
                        <Typography variant="caption">
                            Click the reload button to clear cache data and reload
                        </Typography>
                    </Grid>
                    <Grid container item sm={10}>
                        <Grid item sm={10} container>
                            <Grid item>
                                <Icon>
                                    <Warning color="error" />
                                </Icon>
                            </Grid>
                            <Grid item>
                                <Typography variant="caption">
                                    This action will logout the user
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item sm={2} container justifyContent="flex-end">
                            <ActionButton
                                variant="contained"
                                onClick={onReloadButtonClick}
                            >
                                Reload
                            </ActionButton>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default AppVersionMismatchDialog;
